import React, { useEffect } from 'react';

import { V1Table as Table } from '@uhg-abyss/web/ui/Table';
export const Search = () => {
  var fieldChangeJsonArr = [
    {
      fieldName: 'Last Name',
      description: 'Member Last Name',
    },

    {
      fieldName: 'Severity',
      description: 'Severity code of the processed record',
    },
    {
      fieldName: 'Error or Warning Name',
      description: 'Name of the error or warning',
    },

    {
      fieldName: 'Employee ID',
      description: 'Member number of the employee',
    },
    {
      fieldName: 'Medicaid ID',
      description: 'The ID given by the state for a subscriber.',
    },
  ];

  return (
    <>
      <p>
        The Search Request screen displays once a menu selection has been chosen
        and greater than 1,000 rows are returned. The Search screen allows a
        user to input criteria to narrow down the results displayed for the menu
        choice selected. From the Search screen you may enter criteria for:
      </p>
      <br />

      <ul style={{ listStyleType: 'circle', marginLeft: '5px' }}>
        <li>Last Name</li>
        <li>Severity Error</li>
        <li>Warning Name </li>
        <li>Employee ID (NA for CSP)</li>
        <li>Medicaid ID (Applicable for CSP-Medicaid only)</li>
      </ul>
      <br />
      <b>To enter criteria:</b>
      <p>
        1.Click the drop-down arrow or enter the necessary value next to the
        desired field.
      </p>
      <p>2.Click Continue.</p>

      <br />
      <p>
        <b>Hints for narrowing the results to below the 1000 row limit:</b>
      </p>
      <p>
        To narrow the search on the 'Customer Corrections Required' page, start
        by entering 'Severity' criteria. For example, if a severity of '1' is
        entered, all records with severity '1' errors will be displayed as long
        as 1000 records or less are returned.
      </p>
      <p>
        If the number of records returned still exceeds 1000, enter criteria for
        the Employee ID. A specific Employee ID is not required. The first
        number of an Employee ID may be entered and all Employee IDs beginning
        with the number entered will be displayed if less than 1000 records are
        returned. If more than 1000 records are returned, use the Employee ID
        criteria in combination with Severity.
      </p>
      <p>
        To view the 'Add Transactions' or 'Terms Submitted/Auto-Cancel
        Transactions' page, begin with entering criteria for the Employee ID.
        Enter the first number of an Employee ID to display all Employee IDs
        that begin with the number entered.
      </p>
      <p>
        <mark>
          <b>Note: </b>The search screen displays if the search retrieves
          greater than 1,000 rows.. Also, no changes to the Search Help screen
          other than adding (Employee ID field as N/A for CSP) and Medicaid ID
          field applicable for CSP-Medicaid only.
        </mark>
      </p>
      <b>Field Values / Descriptions</b>
      <Table.Container title="Manual Static Table">
        <Table.TableHeader>
          <Table.TableHeaderRow>
            <Table.Column>Field </Table.Column>
            <Table.Column>Field Description</Table.Column>
          </Table.TableHeaderRow>
        </Table.TableHeader>
        {fieldChangeJsonArr.map((item) => (
          <Table.TableBody>
            {
              <Table.Row>
                <Table.Cell>{item.fieldName}</Table.Cell>
                <Table.Cell>{item.description}</Table.Cell>
              </Table.Row>
            }
          </Table.TableBody>
        ))}
      </Table.Container>
    </>
  );
};
